// extracted by mini-css-extract-plugin
export default {"container":"PbjgL","title":"aR8YC","subtitle":"_4iAIk"};